import * as Factory from 'factory.ts'
import faker from 'faker'

import { type ShippingMethod } from '../../models'

export const ShippingMethodMock = Factory.Sync.makeFactory<ShippingMethod>({
  id: Factory.each(() => faker.random.number()),
  name: Factory.each(() => faker.random.words(4)),
  active: true,
  description: Factory.each(() => faker.random.words(4)),
})
